import { Component, OnInit } from '@angular/core';
import { NgModule } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms'
import { PartnerService } from '../../services/partner.service';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'app-partner-manage-product',
  templateUrl: './partner-manage-product.component.html',
  styleUrls: ['./partner-manage-product.component.scss']
})
export class PartnerManageProductComponent implements OnInit {
  public isPageEditable: boolean = true;
  formSubmitAttempt: boolean = false;
  statusMessage: string = "Loading data please wait...";
  laboratoryTestList: Observable<any>;
  partners: Observable<any>;
  productForm: FormGroup;
  productPriceList: Observable<any>;
  selectedPartnerId: string = "";
  selectedProductId: string = "";
  IsFormEdit: boolean = false;
  public data : any
  constructor(private _partnerService: PartnerService, private router: Router, private fb: FormBuilder) {
    this.productForm = fb.group({
      productTypeId: [],
      recordId: [],
      partnerId: [],
      productId: [],
      price: ['', [Validators.required]],
      currencyType: []

    })
  }

  ngOnInit() {
    this.getPartnerList();
    this.getProductList();
    this.getProductPriceList();
    var loginUser = JSON.parse(localStorage.getItem('currentUser')); 
    this.selectedPartnerId=loginUser.userDetail.partnerId;
  }
  getProductList() {
    this._partnerService.getLaboratoryTest()
      .subscribe(
        (employeeData) => {
          if (employeeData == null) {
            this.statusMessage = "Employee Id does not exist..";
          }
          else {
            this.laboratoryTestList = employeeData.response.productList
          }
          console.log(this.laboratoryTestList);
        },
        (error) => {
          this.statusMessage = "Problem with the service. Please try again after sometime";
          console.log(error);
        }

      );
  }

  getPartnerList() {
    var loginUser = JSON.parse(localStorage.getItem('currentUser')); 
    console.log('loginUser')  
    console.log(loginUser)  

    this._partnerService.getPartners()
      .subscribe(
        (employeeData) => {
          if (employeeData == null) {
            this.statusMessage = "Employee Id does not exist..";
          }
          else {
            this.partners = employeeData.response.partnerList.filter(t=>t.partnerId==loginUser.userDetail.partnerId)
          }
          console.log(this.partners);
        },
        (error) => {
          this.statusMessage = "Problem with the service. Please try again after sometime";
          console.log(error);
        }

      );
  }

  getProductPriceList() {
    var loginUser = JSON.parse(localStorage.getItem('currentUser'));   
    this._partnerService.getPartnerProductsWithPriceDetails()
      .subscribe(
        (employeeData) => {
          if (employeeData == null) {
            this.statusMessage = "Employee Id does not exist..";
          }
          else {
            if (this.selectedPartnerId) {
              //this.productPriceList = employeeData.response.laboratoryTestList
              this.productPriceList = employeeData.response.laboratoryTestList.filter(t => (t.partnerId == this.selectedPartnerId));
            }
            else {
              this.productPriceList = employeeData.response.laboratoryTestList
            }
           
          }
          console.log('this.productPriceList');
          console.log(this.productPriceList);
        },
        (error) => {
          this.statusMessage = "Problem with the service. Please try again after sometime";
          console.log(error);
        }

      );
  }

  AddPartnerProduct(record) {   
    this.formSubmitAttempt = true;
    var date = new Date();
    var loginUser = JSON.parse(localStorage.getItem('currentUser'));
    record.value.partnerId = this.selectedPartnerId;
    record.value.productId = this.selectedProductId;
    record.value.token = loginUser.token;
    if (record.invalid) {
      return;
    }
    else {
      this._partnerService.AddPartnerProduct(record.value).subscribe(
        data => {
          if (data.returnCode == 0) {
            alert("records save Sucessfully")
            this.productForm.reset();
            this.formSubmitAttempt = false;
            this.getProductPriceList()
           
            
          }
          else {
            alert(data.returnMsg)

          }
        },
        error => {
          // this.alertService.error(error);
          // this.loading = false;         
          alert(error)
          console.log(error)
        });
    }
  }

  deletePartnerProduct(record) {   
    let confimationMessage = "Are you sure want to Delete " + record.productName;
    if (confirm(confimationMessage)) {
      var loginUser = JSON.parse(localStorage.getItem('currentUser'));
      record.token = loginUser.token;
      this._partnerService.deletePartnerProduct(record).subscribe(
        data => {
          if (data.returnCode == 0) {
            alert("Record updated sucessfully")

          }
          else {
            if (data.returnCode == 2) {


            }
          }
          this.getProductPriceList();
        },
        error => {
          // this.alertService.error(error);
          // this.loading = false;         
          alert(error)
          console.log(error)
        });

    }
    else {

    }
  }

  selectPartner(record) {
    this.getProductPriceList();
    this.selectedPartnerId = record;
    this.productPriceList = this.productPriceList.filter(t => (t.partnerId == this.selectedPartnerId));
  }

  selectProduct(record) {
    this.selectedProductId = record;
  }

  showUpdate(record) {   
    this.IsFormEdit = true
    this.productForm.controls['price'].setValue(record.price);
    this.selectedProductId = record.productId;
    this.selectedPartnerId = record.partnerId;
    this.productForm.controls['recordId'].setValue(record.recordId);
  }

  updatePartnerProduct(record) {   
    var loginUser = JSON.parse(localStorage.getItem('currentUser'));
    record.value.partnerId = this.selectedPartnerId;
    record.value.productId = this.selectedProductId;
    record.value.token = loginUser.token;
    this._partnerService.updatePartnerProduct(record.value).subscribe(
      data => {
        if (data.returnCode == 0) {
          alert("Record updated sucessfully")
          this.productForm.reset();
          this.formSubmitAttempt = false;   
          this.IsFormEdit = false;      
          this.getProductPriceList();
          
        }
        else {
          alert(data.returnMsg)
        }

      },
      error => {
        // this.alertService.error(error);
        // this.loading = false;         
        alert(error)
        console.log(error)
      });
  }

  reset() {
    this.productForm.reset();
    this.IsFormEdit=false;
  }
  

}



// WEBPACK FOOTER //
// ./src/app/partnerUI/partner-manage-product/partner-manage-product.component.ts